(function (angular) {
    'use strict';

    angular
        .module('app.grievance')
        .config([
            '$stateProvider', 
            '$urlRouterProvider', 
            grievanceRoutes
        ]);

    function grievanceRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.grievance', {
                url: '/grievance',
                templateUrl: '/app/site/grievance/grievance.template.html',
                controller: 'app.grievance.grievanceController',
                controllerAs: 'vmGrievance'
            })
            .state('app.grievanceplus', {
                url: '/grievanceplus',
                templateUrl: '/app/site/grievance/grievance.template.html',
                controller: 'app.grievance.grievanceController',
                controllerAs: 'vmGrievance'
            })
            .state('app.grievancesuccess', {
                url: '/grievancesuccess',
                templateUrl: '/app/site/grievance/success.template.html',
                controller: 'app.grievance.grievanceSuccessController',
                controllerAs: 'vmGrievanceSuccess'
            });
    }
    
})(angular);
